import React, { Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import PropTypes from 'prop-types';

import { Text } from '../index';

import { StyledCard } from './style';

export const QueCard = ({ data, $desktopLayout, ...rest }) => {
    return (
        <StyledCard {...rest}>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: $desktopLayout ? '70% 30%' : '100%',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '20px 0',
                    }}
                >
                    {data ? (
                        <Text
                            $color="pink"
                            style={{
                                fontSize: '64px',
                                textAlign: 'center',
                                maxWidth: '300px',
                            }}
                        >
                            {data?.queueNumber}
                        </Text>
                    ) : (
                        <Skeleton width={150} height={100} variant="text" />
                    )}
                    {data ? (
                        <Text
                            style={{
                                fontSize: '20px',
                                textAlign: 'center',
                                maxWidth: '300px',
                            }}
                        >
                            Your queue number
                        </Text>
                    ) : (
                        <Skeleton width={120} height={50} variant="text" />
                    )}
                    {data ? (
                        <Text
                            $color="gray2"
                            style={{
                                textAlign: 'center',
                                marginTop: '10px',
                                maxWidth: '300px',
                            }}
                        >
                            We’ll send you a notification <br />
                            when we’re almost ready to see you.
                        </Text>
                    ) : (
                        <Fragment>
                            <Skeleton width={200} height={30} variant="text" />
                            <Skeleton width={200} height={30} variant="text" />
                        </Fragment>
                    )}
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: $desktopLayout ? 'column' : 'row',
                    }}
                >
                    {data ? (
                        <Fragment>
                            <StyledCard
                                margin="5px"
                                $maxWidth="165px"
                                padding={$desktopLayout ? '24px' : '20px 10px'}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Text
                                        style={{
                                            textAlign: 'center',
                                            fontSize: '24px',
                                        }}
                                        $color="purple"
                                    >
                                        {data?.watingQueue}
                                    </Text>
                                    <Text
                                        style={{
                                            textAlign: 'center',
                                            fontSize: '14px',
                                        }}
                                    >
                                        in queues
                                    </Text>
                                </div>
                            </StyledCard>
                            <StyledCard
                                margin="5px"
                                $maxWidth="165px"
                                padding={$desktopLayout ? '24px' : '20px 10px'}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Text
                                        style={{
                                            textAlign: 'center',
                                            fontSize: '24px',
                                        }}
                                        $color="purple"
                                    >
                                        {data?.watingTime}
                                    </Text>
                                    <Text
                                        style={{
                                            textAlign: 'center',
                                            fontSize: '14px',
                                        }}
                                    >
                                        Minutes to go
                                    </Text>
                                </div>
                            </StyledCard>
                        </Fragment>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Skeleton width={350} height={100} variant="text" />
                        </div>
                    )}
                </div>
            </div>
        </StyledCard>
    );
};

QueCard.propTypes = {
    data: PropTypes.object.isRequired,
    $desktopLayout: PropTypes.bool,
    rest: PropTypes.object,
};
